import Cookies from 'js-cookie'

import { axiosInstance } from '@/providers/rest-data-provider/utils'

export const operatorKey = 'x-operator-id'

export const getOperatorCookie = (): number | null => Number(Cookies.get(operatorKey)) || null

// The raw x-operator-id scope requests are sent under. Unlike
// getOperatorCookie (which collapses "All" to null for selection restore),
// this distinguishes "All" (cookie "0") from an absent cookie, so callers
// keying state to the request scope observe every change.
export const getOperatorScopeKey = (): string | null => Cookies.get(operatorKey) ?? null

const storedOperatorId = getOperatorCookie()

if (storedOperatorId !== null) {
	axiosInstance.defaults.headers.common[operatorKey] = storedOperatorId
}

const setOperatorRequestHeader = (operatorId: number) => {
	axiosInstance.defaults.headers.common[operatorKey] = operatorId
}

const setOperatorCookie = (operatorId: number) => {
	Cookies.set(operatorKey, String(operatorId), { secure: true, sameSite: 'Strict' })
}

export const setRequestOperatorId = (operatorId: number) => {
	setOperatorRequestHeader(operatorId)
	setOperatorCookie(operatorId)
}
